<template>
  <div
    class="pricing-panel"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <div class="pricing-panel__head">
      <b>{{ title }}</b>
      <BaseDateStepper
        :value="referenceDate"
        label="Data de referência"
        @on-input-date-picker="$emit('update:reference-date', { instance, value: $event })"
      />
    </div>

    <BaseFigures
      :items="figures"
      :instance="instance"
      class="pricing-panel__figures"
    />

    <BaseDashboardTable
      :columns="assetColumns"
      :rows="assets"
      :item-key="itemKey"
      :hide-default-footer="false"
      :server-items-length="serverItemsLength"
      :options="options"
      @detail="$emit('row-detail', $event)"
      @action="$emit('action', $event)"
      @update:options="$emit('update:options', { instance, options: $event })"
    />
  </div>
</template>

<script>
import BaseDateStepper from './BaseDateStepper.vue'
import BaseFigures from './BaseFigures.vue'
import BaseDashboardTable from './BaseDashboardTable.vue'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'

export default {
  name: 'BasePricingPanel',
  mixins: [DashboardHighlightOnRender],
  components: { BaseDateStepper, BaseFigures, BaseDashboardTable },
  props: {
    title: {
      type: String,
      required: true
    },
    referenceDate: {
      type: String,
      required: true
    },
    figures: {
      type: Array,
      required: true
    },
    assetColumns: {
      type: Array,
      required: true
    },
    assets: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.pricing-panel {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__figures {
    margin-bottom: 16px;
  }
}
</style>
